var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{fill:#195DA9;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible",
      enableBackground: "new"
    },
    width: 40,
    height: 40,
    xlinkHref: "68B16864.png",
    transform: "matrix(1.25 0 0 1.2245 0 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 25,
    cy: 25,
    r: 25
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13,27v12h8v-7h8v7h8V27c-4-3.7-8-7.3-12-11C21,19.7,17,23.3,13,27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37,27C29,27,37,27,37,27L25,16L13,27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calque_4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "7.3,26 25,9.8 26.7,12 9.2,28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "42.7,26 25,9.8 23.4,12.1 40.8,28.1  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-7.3,34.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.86b5627792f12dc1eab2d14f0dd91c7d.svg";
export { ForwardRef as ReactComponent };